module.exports = __webpack_public_path__ + "img/9788930316170.338bbd1d.jpg";